import React, {useState} from "react";
import { imageURl,CreateQuizUrl } from "../../libs/env";
export function SelectChoice({ choices = [], onblur, isReview , id,...restprops }) {
  const [color, setColor] = useState(isReview ? "black" : "grey");
  const onchange = (e)=>{
    if (e.target.value) {
      setColor("black")
    }
  }
  
  return (
    <div className={`d-inline-flex lg-mx-1 select_mb_1 ${choices.length === 0 && window.location.pathname.includes(CreateQuizUrl) ? "dropload": ""} `}>
      <select
       
        className="form-select no-download"
        style={{
           color: color,
          borderColor: "#2f56a1",
          backgroundImage: `url("${imageURl}/arrow-down.png")`
        }}
        onChange={onchange}
        onBlur={onblur}
        {...restprops}
      >
        {isReview ? null :  <option selected value="" disabled hidden>select answer</option>}
        {choices &&
          choices.map((choice, index) => (
            <option class="text-dark" key={choice.number} data-possible-question-id={choice.id} selected={id === choice.id ? true : false}>
              {choice.prompt_content.replaceAll(/(<([^>]+)>)/gi, "")}
            </option>
          ))}
        ;
      </select>
      {/* <select
       className="form-select-custom-sm d-none  pdf-download rounded-3"
       style={{
          color: color,
         borderColor: "#2f56a1",
         paddingRight: "4rem",
         paddingLeft: "4rem",
       }}
     >
       {isReview ? null :  <option selected value="" disabled hidden></option>}
       ;
     </select> */}
    </div>
  );
}
